//
//  SDKSize.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class Size {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b;
        this.width = (_a = model === null || model === void 0 ? void 0 : model.width) !== null && _a !== void 0 ? _a : null;
        this.height = (_b = model === null || model === void 0 ? void 0 : model.height) !== null && _b !== void 0 ? _b : null;
    }
}
